<template lang="pug">
div
  v-dialog(v-model="dialog", max-width="600", persistent)
    form.Poppins(@submit.prevent="salvar()", style="width: 100%;")
      v-card.br-10
        v-card-title.subheading.Poppins {{ form.id ? 'Editar área de entrega' : 'Nova área de entrega' }}
        v-card
          v-card-text
            v-layout(row, wrap)
              v-flex.xs12.mb-3
                v-text-field.inputDefault(
                  outline,
                  label="Nome da área",
                  placeholder="Ex.: região do centro",
                  v-model="form.nome",
                  maxlength="100",
                  color="primary",
                  :hide-details="true"
                )
              v-flex.xs12.sm6.pr-2
                v-currency-field.inputDefault(outline, label="Raio (km)", v-model="form.raio", v-bind="raio_config", color="primary", :hide-details="true")
              v-flex.xs12.sm6.pl-2
                v-currency-field.inputDefault(outline, label="Taxa de entrega", v-model="form.valor", v-bind="currency_config", color="primary", :hide-details="true")
          v-card-actions
            v-spacer
            v-btn(flat, :disabled="loading", type="button", @click="dialog = false") Fechar
            v-btn.br-5(color="primary", :loading="loading", type="submit", style="color: #fff; box-shadow: none;") Salvar

  v-layout.Poppins(row, wrap)
    v-flex.xs12
      v-card.px-3.pt-0.pb-2.br-10.cardPadrao
        v-layout(row, wrap, align-center)
          v-flex.xs12
            h3.mb-1 Áreas de entrega por raio
            small(style="color: #9A9A9A;") A taxa cobrada é a da menor faixa que cobre a distância entre a loja e o endereço do cliente.

        v-layout.mt-2(row, wrap, v-if="origem")
          v-flex.xs12
            small(style="color: #9A9A9A;")
              i.fa.fa-map-marker.pr-1(style="color: #1d9a5a;")
              | Origem do raio: {{ origem.nome }}

        v-alert.mt-3.br-10(:value="!origem && !loadingAreas", type="error", outline)
          | Nenhum endereço com coordenadas cadastrado para a loja. Fale com o suporte para cadastrar o endereço antes de cobrar por geolocalização.

        v-alert.mt-3.br-10(:value="!loadingAreas && !!origem && !areasAtivas.length", type="warning", outline)
          | Nenhuma área de entrega ativa. Enquanto não houver ao menos uma faixa, a loja não atende nenhum endereço.

        v-alert.mt-3.br-10(:value="avisoTaxaDecrescente", type="warning", outline)
          | Existe uma faixa mais distante com taxa menor que a de uma faixa mais próxima. Confira os valores.

  v-layout.Poppins(row, wrap)
    v-flex.xs12
      v-card.pa-3.br-10.cardPadrao
        v-layout.mb-3(row, wrap)
          v-flex.md10.xs12
            v-text-field.Poppins.inputDefault(
              label="Buscar por nome da área",
              color="primary",
              height="50px",
              v-model="search",
              clearable,
              outline,
              :hide-details="true",
              prepend-inner-icon="search",
              :disabled="loading"
            )
          v-spacer
          v-flex.md2.xs12
            v-btn.ma-0.xs12.br-10.mt-0.Poppins.botaoNovaArea(color="primary", depressed, @click="novaArea()", :disabled="loading")
              i.fa.fa-plus.pr-2
              | Nova área
        v-data-table(:headers="headers", :items="areas", hide-actions, :search="search", :loading="loadingAreas", color="primary", no-data-text="Nenhuma área de entrega cadastrada", no-results-text="Nenhuma área encontrada")
          template(slot="items", slot-scope="props")
            tr(:class="{'red lighten-4': props.item.ativo != 1}")
              td.text-xs-left {{ props.item.nome }}
              td.text-xs-left até {{ formatarRaio(props.item.raio) }} km
              td.text-xs-left {{ formatarTaxa(props.item.valor) }}
              td.text-xs-left {{ props.item.ativo == 1 ? 'Ativa' : 'Desativada' }}
              td.text-xs-right
                v-menu(offset-y)
                  v-btn.br-5(slot="activator", color="gray", outline, small) Ações
                    v-icon arrow_drop_down
                  v-list
                    v-list-tile.Poppins(@click="editarArea(props.item)", v-if="props.item.ativo == 1")
                      v-list-tile-title Editar
                    v-list-tile.Poppins(@click="removerArea(props.item)", v-if="props.item.ativo == 1")
                      v-list-tile-title Desativar
                    v-list-tile.Poppins(@click="reativarArea(props.item)", v-if="props.item.ativo != 1")
                      v-list-tile-title Reativar
        small.mt-2.d-block(v-if="areas.length > areasAtivas.length", style="color: #a94442;")
          | As faixas em vermelho estão desativadas e não atendem pedidos, mas o raio delas continua reservado. Reative a faixa ou cadastre o mesmo raio para sobrescrevê-la.
</template>

<script>
export default {
  data () {
    return {
      areas: [],
      origem: null,
      search: '',
      loading: false,
      loadingAreas: false,
      dialog: false,
      form: this.formVazio(),
      headers: [
        { text: 'Nome', value: 'nome' },
        { text: 'Raio', value: 'raio' },
        { text: 'Taxa de entrega', value: 'valor' },
        { text: 'Situação', value: 'ativo' },
        { text: 'Ações', sortable: false, align: 'right' },
      ],
      currency_config: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
        min: 0,
      },
      raio_config: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' km',
        precision: 1,
        masked: false,
        min: 0,
      },
    };
  },
  computed: {
    estabelecimentoSelecionado () {
      return this.$root.estabelecimentoSelecionado;
    },
    areasAtivas () {
      return this.areas.filter(area => area.ativo == 1);
    },
    // O raio maior sempre deve custar pelo menos o mesmo que o menor.
    avisoTaxaDecrescente () {
      return this.areasAtivas.some((area, indice) => indice > 0 && Number(area.valor) < Number(this.areasAtivas[indice - 1].valor));
    },
  },
  created () {
    window.getApp.$on('CHANGE_ESTABELECIMENTO', this.init);
  },
  beforeDestroy () {
    window.getApp.$off('CHANGE_ESTABELECIMENTO', this.init);
  },
  mounted () {
    this.init();
  },
  methods: {
    formVazio () {
      return { id: null, nome: null, raio: 0, valor: 0 };
    },
    arredondarRaio (valor) {
      return Math.round(parseFloat(valor) * 10) / 10;
    },
    formatarRaio (valor) {
      return this.arredondarRaio(valor).toFixed(1).replace('.', ',');
    },
    formatarTaxa (valor) {
      return Number(valor) === 0 ? 'Entrega Grátis' : this.$options.filters.currency(valor);
    },
    showErrorMsg (error, defaultMsg) {
      const err = error && error.response && error.response.data ? error.response.data.error : defaultMsg;
      window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
    },
    showSuccessMsg (msg) {
      window.getApp.$emit('APP_ALERT', { color: 'green', text: msg });
    },
    init () {
      this.getAreas();
      this.getOrigem();
    },
    // Lista ativas e desativadas: o raio de uma faixa desativada continua ocupado no banco.
    async getAreas () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        vm.loadingAreas = true;
        const { data } = await vm.$axios.get('/area-entrega', {
          params: { estabelecimento_id: vm.estabelecimentoSelecionado.id },
        });
        vm.areas = (data || []).map(area => ({
          ...area,
          raio: parseFloat(area.raio),
          valor: parseFloat(area.valor),
          ativo: parseInt(area.ativo),
        }));
      } catch (error) {
        vm.showErrorMsg(error, 'Ocorreu um erro ao carregar as áreas de entrega!');
      } finally {
        vm.loadingAreas = false;
      }
    },
    async getOrigem () {
      const vm = this;
      try {
        if (!vm.estabelecimentoSelecionado) return;
        const { data } = await vm.$axios.get('/area-entrega/origem', {
          params: { estabelecimento_id: vm.estabelecimentoSelecionado.id },
        });
        vm.origem = data || null;
      } catch (error) {
        vm.origem = null;
      }
    },
    novaArea () {
      this.form = this.formVazio();
      this.dialog = true;
    },
    editarArea (area) {
      this.form = { ...area };
      this.dialog = true;
    },
    descreverTaxa (valor) {
      return parseFloat(valor) === 0 ? 'entrega grátis' : `R$ ${parseFloat(valor).toFixed(2).replace('.', ',')}`;
    },
    confirmarSubstituicao (duplicada, area) {
      const acao = duplicada.ativo == 1 ? 'sobrescrita' : 'sobrescrita e reativada';
      const frases = [`A faixa "${duplicada.nome}" (taxa ${this.descreverTaxa(duplicada.valor)}) será ${acao} com os dados informados.`];

      if (area.id) {
        frases.push(`A faixa "${area.nome}" que você está editando será removida para não duplicar o raio.`);
      }

      return this.$confirm(frases.join(' '), {
        title: `Já existe uma área com raio de ${this.formatarRaio(area.raio)} km!`,
        buttonTrueText: 'Sobrescrever',
        buttonFalseText: 'Cancelar',
      });
    },
    async salvar () {
      const vm = this;
      const area = vm.form;

      if (!vm.estabelecimentoSelecionado) return;
      if (!area.nome) return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Informe o nome da área de entrega!' });
      if (!area.raio || parseFloat(area.raio) <= 0) return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Informe um raio maior que zero!' });

      const raio = vm.arredondarRaio(area.raio);
      const duplicada = vm.areas.find(item => parseInt(item.id) !== parseInt(area.id || 0) && vm.arredondarRaio(item.raio) === raio);

      if (duplicada && !(await vm.confirmarSubstituicao(duplicada, area))) return;

      // Com raio duplicado o alvo é o registro existente: sobrescreve em vez de cadastrar outro.
      const alvo = duplicada || area;
      const payload = {
        estabelecimento_id: vm.estabelecimentoSelecionado.id,
        nome: area.nome,
        raio,
        valor: parseFloat(area.valor || 0),
      };
      if (alvo.id) {
        payload.id = alvo.id;
        payload.ativo = 1;
      }

      try {
        vm.loading = true;

        if (payload.id) await vm.$axios.put('/area-entrega', payload);
        else await vm.$axios.post('/area-entrega', payload);

        if (duplicada && area.id && parseInt(area.id) !== parseInt(duplicada.id)) {
          await vm.$axios.delete('/area-entrega', { params: { id: area.id } });
        }

        vm.dialog = false;
        vm.form = vm.formVazio();
        vm.showSuccessMsg(duplicada ? 'Área de entrega sobrescrita com sucesso!' : 'Área de entrega salva com sucesso!');
        vm.getAreas();
      } catch (error) {
        vm.showErrorMsg(error, 'Ocorreu um erro ao salvar a área de entrega!');
      } finally {
        vm.loading = false;
      }
    },
    async removerArea (area) {
      const vm = this;
      if (vm.areasAtivas.length <= 1)
        return window.getApp.$emit('APP_ALERT', { color: 'red', text: 'É necessário manter pelo menos uma área de entrega ativa!' });

      const confirmado = await vm.$confirm('Os pedidos dessa faixa de distância deixam de ser atendidos.', {
        title: `Desativar a área "${area.nome}"?`,
        buttonTrueText: 'Desativar',
        buttonFalseText: 'Cancelar',
      });
      if (!confirmado) return;

      try {
        vm.loading = true;
        await vm.$axios.delete('/area-entrega', { params: { id: area.id } });
        vm.showSuccessMsg('Área de entrega desativada!');
        vm.getAreas();
      } catch (error) {
        vm.showErrorMsg(error, 'Ocorreu um erro ao desativar a área de entrega!');
      } finally {
        vm.loading = false;
      }
    },
    async reativarArea (area) {
      const vm = this;
      const confirmado = await vm.$confirm(`A faixa de até ${vm.formatarRaio(area.raio)} km volta a ser atendida.`, {
        title: `Reativar a área "${area.nome}"?`,
        buttonTrueText: 'Reativar',
        buttonFalseText: 'Cancelar',
      });
      if (!confirmado) return;

      try {
        vm.loading = true;
        await vm.$axios.put('/area-entrega', {
          id: area.id,
          estabelecimento_id: vm.estabelecimentoSelecionado.id,
          nome: area.nome,
          raio: vm.arredondarRaio(area.raio),
          valor: parseFloat(area.valor || 0),
          ativo: 1,
        });
        vm.showSuccessMsg('Área de entrega reativada!');
        vm.getAreas();
      } catch (error) {
        vm.showErrorMsg(error, 'Ocorreu um erro ao reativar a área de entrega!');
      } finally {
        vm.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .Poppins{
    font-family: "Poppins", "Roboto", "Helvetica";
  }
  .br-5{
    border-radius: 5px !important;
  }
  .br-10{
    border-radius: 10px !important;
  }
  .cardPadrao{
    box-shadow: none !important;
    background-color: transparent;
  }
  .d-block{
    display: block;
  }
  .botaoNovaArea{
    color: #fff;
    height: 56px;
    width: 100%;
    font-size: 16px;
    font-weight: 700;
    text-transform: capitalize;
  }
</style>
